import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { FaHome, FaUser } from "react-icons/fa";
//import { CiSettings } from "react-icons/ci";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [username, setUsername] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    setIsMenuOpen(false);
    alert("You have been logged out!");
    navigate("/login");
  };

  const getProfileInitial = () => {
    return username ? username.charAt(0).toUpperCase() : "U";
  };

  const closeMenus = () => {
    setIsOpen(false);
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 shadow-lg">
      <div className="  px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            className="text-2xl text-white font-extrabold tracking-wide hover:text-gray-200 transition-colors duration-300"
          >
            TechHook
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            <nav className="flex space-x-8">
              <Link
                to="/post"
                className="text-white font-mono hover:text-indigo-100 font-medium transition-all duration-300 hover:scale-105"
              >
                Glance
              </Link>
              <Link
                to="/blog"
                className="text-white font-mono hover:text-indigo-100 font-medium transition-all duration-300 hover:scale-105"
              >
                Dashboard
              </Link>
              <Link
                to="/profile"
                className="text-white font-mono hover:text-indigo-100 font-medium transition-all duration-300 hover:scale-105"
              >
                Profile
              </Link>
            </nav>

            {/* Desktop User Menu */}
            {username ? (
              <div className="relative">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="flex items-center space-x-3 text-white hover:text-indigo-100 focus:outline-none transition-colors duration-300"
                >
                  <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-pink-500 border-2 border-white rounded-full flex items-center justify-center">
                    {getProfileInitial()}
                  </div>
                  <span className="font-medium">{username}</span>
                </button>

                {isMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl py-2 z-50">
                    <Link
                      to="/"
                      className="flex items-center text-black font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
                    >
                      <FaHome className="inline mr-2 text-xl" />
                      Home
                    </Link>

                    <Link
                      to="/profile"
                      className="flex items-center text-black font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
                    >
                      <FaUser className="inline mr-2 text-xl" />
                      Profile
                    </Link>

                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                    >
                      <FaSignOutAlt className="mr-2 rotate-180 text-xl" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                className="flex items-center text-white hover:text-indigo-100 font-medium transition-all duration-300 hover:scale-105"
              >
                <FaSignInAlt className="mr-2" />
                Login
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/20 transition-colors duration-200"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } md:hidden border-t border-white/10 py-2`}
        >
          <nav className="flex flex-col space-y-2 py-2">
            <Link
              to="/post"
              className="text-white font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
              onClick={closeMenus}
            >
              Glance
            </Link>
            <Link
              to="/blog"
              className="text-white font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
              onClick={closeMenus}
            >
              Dashboard
            </Link>
            <Link
              to="/profile"
              className="text-white font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Profile
            </Link>
            {username ? (
              <button
                onClick={handleLogout}
                className="text-white font-mono hover:bg-white/10 px-4 py-2 rounded-lg text-left transition-colors duration-200"
              >
                <FaSignOutAlt className="inline mr-2 rotate-180" />
                Logout
              </button>
            ) : (
              <Link
                to="/login"
                className="text-white font-mono hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200"
                onClick={closeMenus}
              >
                <FaSignInAlt className="inline mr-2" />
                Login
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
